import { render, staticRenderFns } from "./FilterSummaryOptionTapirMd.vue?vue&type=template&id=2d818013&"
import script from "./FilterSummaryOptionTapirMd.vue?vue&type=script&lang=js&"
export * from "./FilterSummaryOptionTapirMd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports